import { render, staticRenderFns } from "./TypeAndValueInput.vue?vue&type=template&id=cbed8818&scoped=true&"
import script from "./TypeAndValueInput.vue?vue&type=script&lang=js&"
export * from "./TypeAndValueInput.vue?vue&type=script&lang=js&"
import style0 from "./TypeAndValueInput.vue?vue&type=style&index=0&id=cbed8818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed8818",
  null
  
)

export default component.exports